import React from "react";

import { FormattedMessage } from "react-intl";

// Bootstrap
import { Row, Col } from "react-bootstrap";

// Styles
import "./index.scss";

const Footer = () => {
  React.useEffect(() => {
    const script = document.createElement("script");
    script.src =
      "https://cmp.osano.com/AzyzptTmRlqVd2LRf/243f7db2-8385-427b-948d-2caccb95300a/osano.js";
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  return (
    <>
      <footer className="page-footer">
        <div className="footer-menu">
          <div className="container-fluid footer-menu-container p-0">
            <div className="row p-0 pl-2">
              <Col sm={9} className="p-0 pt-2">
                <Row>
                  <Col>
                    <nav className="navbar navbar-expand-md navbar-light pl-0 footer-menu-navbar">
                      <div
                        className="collapse navbar-collapse"
                        id="navbarCollapse"
                      >
                        <div className="navbar-nav footer-menu-navbar-nav">
                          <a
                            href="https://entities.standards.ieee.org/"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <FormattedMessage id="page.footer.menu.link1" />
                          </a>
                          <a
                            href="https://standards-support.ieee.org/hc/en-us/requests/new"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <FormattedMessage id="page.footer.menu.link3" />
                          </a>
                          <a
                            href="https://www.ieee.org/accessibility-statement.html"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <FormattedMessage id="page.footer.menu.link4" />
                          </a>
                          <a
                            href="https://www.ieee.org/about/corporate/governance/p9-26.html"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <FormattedMessage id="page.footer.menu.link5" />
                          </a>
                          <a
                            href="https://secure.ethicspoint.com/domain/media/en/gui/20410/index.html"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <FormattedMessage id="page.footer.menu.link6" />
                          </a>
                          <a
                            href="https://www.ieee.org/about/help/site-terms-conditions.html"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <FormattedMessage id="page.footer.menu.link7" />
                          </a>
                          <a
                            href="https://www.ieee.org/security-privacy.html"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <FormattedMessage id="page.footer.menu.link8" />
                          </a>
                          <a
                            href="https://ieee.app.box.com/v/obligationsforparticipation"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <FormattedMessage id="page.footer.menu.link9" />
                          </a>
                        </div>
                      </div>
                    </nav>
                  </Col>
                </Row>
              </Col>
            </div>
            <div className="row pl-2">
            <Row>
              <Col className="footer-menu-copyrights">
                  <span>
                    <FormattedMessage
                      id="page.footer.copyright"
                        defaultMessage="© Copyright {curyear} IEEE - All rights reserved. A public charity, IEEE is the world's largest technical professional organization dedicated to advancing technology for the benefit of humanity."
                      values={{
                        curyear: new Date().getFullYear(),
                      }}
                    />
                  </span>
              </Col>
            </Row>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
